import { render, staticRenderFns } from "./PaymentAllBanksButton.vue?vue&type=template&id=4ab6814e&scoped=true&"
import script from "./PaymentAllBanksButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PaymentAllBanksButton.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PaymentAllBanksButton.vue?vue&type=style&index=0&id=4ab6814e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab6814e",
  null
  
)

export default component.exports